<template>
    <DetailPage class="order-add-box" :name="mode == 'save' ? '新增订单': '编辑订单'">
      <template #detailMain>
        <div class="wrapper">
          <header class="order-add-hd">
              <el-form :inline="true"  @submit.native.prevent>
                <el-col :span="6">
                  <el-form-item label="用户类型" required> 
                    <el-select v-model="person" style="width:100%;">
                      <el-option v-for="item in persons" :label="item.text" :key="item.value" :value="item.value"> </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                
                <el-col :span="6">
                  <el-form-item  label="选择用户" required>
                    <el-input v-if="person == '2'" readonly="readonly" v-model="checkPerson" @click.native="handleUser(2)" placeholder="请选择" style="width:100%;" clearable></el-input>
                    <el-input v-else readonly="readonly" v-model="checkUser" @click.native="handleUser(1)" placeholder="请选择" style="width:100%;" clearable></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="6">
                  <el-form-item  label="生效时间" required>
                    <el-date-picker  v-model="effectiveTime"  type="date"  placeholder="生效时间"  style="width:210px;" :clearable="false"></el-date-picker>
                  </el-form-item>
                </el-col>

                <el-col :span="6">
                  <el-form-item label="订单类型" required>
                      <el-select v-model="orderType" placeholder="订单类型" style="width:100%;" @change="handerOrderType">
                        <el-option v-for="item in orderTypes" :key="item.value" 
                          :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
              </el-form>
          </header>

          <section class="order-add-bd" v-loading="listLoading">
            <!-- 产品列表 -->
            <div class="product-list">
                <h4 class="list-hd title">选择产品</h4>
                <ul class="list-bd fit-w">
                  <li class="list-item" :class="{ active: selectProList.findIndex( data => data.id == item.id) > -1 }" v-for="item in proList" :key="item.id" @click="handerProduct(item)">
                    <span class="dnnfont iconaccomplish-filled"></span>
                    <img :src="item.logo" alt="" class="proLogo" />
                    <h4 class="proName">{{ item.name }}</h4>
                  </li>
                </ul>
            </div>
            
            <!-- 已选产品 -->
            <div class="product-list-selected">
              <h4 class="title">订单清单</h4>
              <article class="fit-w list-selected-info">
                <header class="tab-hd">已选择{{ selectProList.length }}个产品</header>
                <SelectedProduct :productLists="selectProList" :isEdit="true" @del="(data) => handerProduct(data)" />
              </article>
            </div>
          </section>
        </div>

      <!-- 订单提交栏 -->
      <footer :span="24" class="order-add-ft">
        <el-form :inline="true"  @submit.native.prevent >

            <el-col :span="24">
              <el-form-item label="预估价格:" class="order-evaluate" style="color: #EB6264">
                {{ evaluatePrice }} 元
              </el-form-item> 
            </el-col>

           <el-col :span="24">
              <el-form-item label="订单总价:" class="order-total">
                <el-input class="price" :disabled="isOrderTest" oninput="this.value=this.value.replace(/[^\d]/g,'');" v-model="totalPrice" style="width:200px;">
                    <template slot="append">元</template>
                </el-input>
              </el-form-item>
           </el-col>

           <el-col :span="24" class="ft-submit">  
            <el-form-item>
              <el-button type="primary" class="gradual" :loading="orderSubLoading" :disabled="selectProList.length == 0" @click="orderSubmit">提交订单</el-button>
            </el-form-item>
            </el-col>
        </el-form>
      </footer>

      <!--订单个人账户-->
      <el-dialog class="model-edit" title="订单账户" :visible.sync="orderVisible" 
        :close-on-click-modal="false">
        <el-col :span="24" class="toolbar">
          <el-form :inline="true" :model="souchs2" @submit.native.prevent>
             <!-- <el-form-item>
                <el-select v-model="value" placeholder="请选择" @change="changeSouch"  style="width:120px;">
                  <el-option v-for="item in optionsSouch" :key="item.value"  
                    :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
             </el-form-item> -->
              <el-form-item>
                  <el-input  v-model="searchText"  placeholder="账号 / 姓名" style="width:180px;" clearable  @keyup.enter.native="getUser(1)"></el-input>
              </el-form-item>
               <!-- <el-form-item>
             <el-input v-show="disSouch" v-model="proName" style="width:200px;"  @keyup.enter.native="getUser(1)"></el-input>
              <el-select v-show="disinvit" v-model="souchs2.invitValue" placeholder="请选择" style="width:200px;" clearable >
                <el-option v-for="item in inviValues" :key="item.value" 
                  :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <el-select v-show="disSofttype" v-model="souchs2.softtype" placeholder="请选择" style="width:200px;" clearable >
                <el-option v-for="item in softtypes" :key="item.value" 
                  :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <el-date-picker v-show="disTime1" style="width:200px;"  v-model="souchs2.fromtime" format="yyyy-MM-dd" 
                  value-format="yyyy-MM-dd" type="date" placeholder="开始日期时间"> 
              </el-date-picker>
              <el-date-picker v-show="disTime2" style="width:200px;"  v-model="souchs2.totime" format="yyyy-MM-dd" 
                value-format="yyyy-MM-dd" type="date" placeholder="结束日期时间"> 
              </el-date-picker>
            </el-form-item> -->
            <el-form-item>
              <el-button type="primary"  size="medium" v-on:click="getUser(1)">查询</el-button>
            </el-form-item>
          </el-form>
          <!-- <el-tag :key="tag" v-for="tag in dynamicTags" closable 
            :disable-transitions="false" @close="handleClose(tag)"> 
              {{tag}} 
          </el-tag>
          <el-button v-if="dynamicTags!=''" class="button-new-tag" size="small" @click="delTags">清除标签</el-button> -->
        </el-col>

        <!--用户列表-->
        <el-table  :data="users" highlight-current-row v-loading="dialogLoading"  style="width: 100%;" 
        ref="users" :header-cell-style="getRowClass" @row-click="handleSelectionChange">
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.checked"></el-checkbox> 
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="账号" min-width="130" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="name" label="姓名" min-width="100" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="softtype" label="软件类型"  min-width="120" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="company" label="企业" min-width="160" show-overflow-tooltip>
          </el-table-column>
        </el-table>
        <!--工具条-->
        <el-col :span="24" class="toolbar" style="padding: 10px 0">
          <el-pagination 
            layout=" prev, pager, next" :current-page="pageNumber2" @current-change="handleCurrentChange2" 
            :page-size="pageSize2"  :total="total2" style="float:right;">
          </el-pagination>
        </el-col>
        <div slot="footer" class="dialog-footer" style="text-align:center">
          <el-button @click.native="orderVisible = false, searchText=''">取消</el-button>
          <el-button type="primary" @click.native="orderUserSubmit" :loading="orderLoading">确定</el-button>
        </div>
      </el-dialog>

      <!--订单企业账户-->
      <el-dialog class="model-edit" title="订单账户" :visible.sync="personVisible" 
        :close-on-click-modal="false">
        <el-col :span="24" class="toolbar">
          <el-form :inline="true" :model="souchs3" @submit.native.prevent>
            <el-form-item>
                  <el-input  v-model="searchText"  placeholder="企业名称" clearable style="width:180px;"  @keyup.enter.native="getPerson(1)"></el-input>
              </el-form-item>
            <!-- <el-form-item>
              <el-select v-model="value3" placeholder="请选择" @change="changeSouch3"  style="width:120px;">
                <el-option v-for="item in options3" :key="item.value"  
                  :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>  
            <el-form-item>
              <el-input  v-model="proName3" style="width:200px;"  @keyup.enter.native="getPerson(1)"></el-input>
            </el-form-item> -->
            <el-form-item>
              <el-button type="primary" size="medium" v-on:click="getPerson(1)">查询</el-button>
            </el-form-item>
          </el-form>
          <!-- <el-tag :key="tag3" v-for="tag3 in dynamicTags3" closable 
            :disable-transitions="false" @close="handleClose3(tag3)"> 
              {{tag3}} 
          </el-tag>
          <el-button v-if="dynamicTags3!=''" class="button-new-tag" size="small" @click="delTags3">清除标签</el-button> -->
        </el-col>
        <!--用户列表-->
        <el-table  :data="personList" highlight-current-row v-loading="dialogLoading"  style="width: 100%;" 
        ref="personList" :header-cell-style="getRowClass" @row-click="handleSelectionChange3">
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <!-- <el-checkbox @change="changeFun" v-model="scope.row.checked"></el-checkbox>  -->
              <el-checkbox v-model="scope.row.checked" @change="changeFun3"></el-checkbox> 
            </template>
          </el-table-column>
          <el-table-column prop="id" label="ID" min-width="140" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="managername" label="公司管理员" min-width="140" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="name" label="企业名称" min-width="180"  show-overflow-tooltip>
          </el-table-column>
        </el-table>
        <!--工具条-->
        <el-col :span="24" class="toolbar" style="padding: 10px 0;">
          <el-pagination 
            layout=" prev, pager, next" :current-page="pageNumber3" @current-change="handleCurrentChange3" 
            :page-size="pageSize3"  :total="total3" style="float:right;">
          </el-pagination>
        </el-col>
        <div slot="footer" class="dialog-footer" style="text-align:center">
          <el-button @click.native="personVisible = false, searchText=''">取消</el-button>
          <el-button type="primary" @click.native="orderPersonSubmit" :loading="orderLoading">确定</el-button>
        </div>
      </el-dialog>

      </template>
    </DetailPage>
     
 	
 
</template>
<script>
import { API__code, API_User ,API_Product,imgURLs, API_Order,API_Admin} from '../../../api/index.js'
import Util from '../../../utils/index'
import DetailPage from '@/components/DetailPage'
import SelectedProduct from './SelectedProduct'
import { mapGetters } from 'vuex'
export default {
  data(){
    return {
      searchText: '',
      effectiveTime:new Date(),//生效时间
      effectiveTimeSfm:'00:00:00',
      proName3:"",
      dynamicTags3: [],
      options3: [
        {value: 'ID',label: 'ID'}, 
        {value: '企业名称',label: '企业名称'},
        {value: '管理员',label: '管理员'},
      ],
      
      // 用户类型
      person:'1',
      persons:[
				{ value: "1", text: "个人用户" },
				{ value: "2", text: "企业用户" },
      ],
      
      // 订单类型
      orderType: '1',
      orderTypes:[
        {value: '1',label: '试用订单'},
        {value: '2',label: '正式订单'},
        // {value: '3',label: '续费'}
      ],

      mode: 'save',
      orderId: '',
      processDetail: null,
      
      proList:[],          // 可选产品列表
      selectProList:[],    // 已选产品列表
      listLoading:false,
      totalPrice:0,        // 订单总价

      value3: '',

      souchs2:{},
      disSouch:true,
      disinvit:false,  
      disSofttype:false,
      disTime1:false,
      disTime2:false,
      proName:"",
      dynamicTags: [],
      optionsSouch: [
        {value: '账号',label: '账号'}, 
        {value: '姓名',label: '姓名'},
        {value: '企业',label: '企业'},
        {value: '软件类型',label: '软件类型'},
        {value: '邀请状态',label: '邀请状态'},
        {value: '开始日期',label: '开始日期'},
        {value: '结束日期',label: '结束日期'},
      ],
      value: '',
      inviValues:[],
      softtypes:[],

      souchs3:{
        name:'',
      },
      personList:[],
      personVisible:false,
      personLoading:false,
      pageNumber3:1,
      pageSize3:10,
      total3:0,
      orderLoading:false,
      checkPerson:'',
      checkPersonId:'',
      
      checkPerson2:'',
      checkPersonOld:'',
      checkPersonIdOld:'',
      flag2:false,

      orderSubLoading:false,
      
    
      token:'',
      checkCode:"",
      id:"",
      isDisabled:true,
      orderVisible:false,
      orderLoading:false,
      userLoading:false,
      pageNumber2:1,
      pageSize2:10,
      total2:0,
      
      users:[],
      flag:false,
      checkUser:'',
      checkUser2:'',
      checkUserOld:'',
      checkUserId:'',
      checkUserIdOld:'',
      
      dialogLoading: false,
    }
  },

  computed: {
     ...mapGetters(['userInfo', ]),
    // 是否是试用订单
    isOrderTest() {
      return this.orderType == 1
    },
    
    // 计算预估价格
    evaluatePrice() {
      let price = 0;
      price = this.selectProList.reduce((previousValue, curItem) => {
        return previousValue + (curItem.purchaseNum * curItem.purchaseMonth * curItem.price)
      },0)

      this.totalPrice = price
      return price
    },
  },

  components: {
    DetailPage,
    SelectedProduct
  },

  created(){
     let { mode, orderId } = this.$route.query
    this.orderId = orderId
   
    
    this.getCookie();
    
    // 编辑模式
    if(mode) {
      this.mode = mode;
      this.getDetail();
    }else {
       this.getProList();
    }
    console.log('this.mode==', this.mode)
    
  },

  mounted(){
   
    this.getUser();
    this.getPerson();
    this.getCode1();
    this.getCode();
  },

  methods: {

    getDetail() {
      let param = {
        token: this.token,
        checkCode: this.checkCode,
        id: this.$route.query.orderId,
      }
      API_Order.detailOrder(param).then(res => {
         if(res.data.code == 200) {
           this.processDetail = res.data.data
           try {
              this.processDetail.product = JSON.parse(this.processDetail.product);
              this.processDetail.product.forEach(item => {
                item.price = item.singlePrice
                item.name = item.productName;
                item.logo = ''
                item.id = item.productId
              })

              //  初始化数据
              // TODO联调
              let { type , effectivetime, userid, username, companyid, companyname } =  res.data.data
              
              // 个人用户企业用户
              this.person = userid? '1': '2'     
              
              // 用户
              this.checkUserId = userid           
              this.checkUser = username
              
              // 企业名称
              this.checkPersonId = companyid
              this.checkPerson = companyname
              // 生效时间
              this.effectiveTime = effectivetime
              
              // 订单类型
              this.orderType = type

              this.selectProList = [... this.processDetail.product]
              this.getProList()
           } catch(e) {
             this.processDetail.product = []
           }
         }
       })
    },
    
    // 订单类型改变
    handerOrderType(type) {
      // 试用订单： 总价为0，正式订单默认取预估价格
      this.totalPrice = type == 1? 0: this.evaluatePrice
    },
    
    // 选择、取消选择产品
    handerProduct(data) {
      let index = this.selectProList.findIndex( item => item.id == data.id)
      if( this.selectProList.length == 0 || index == -1) {
        this.selectProList.push(data)
      }

      if(index > -1) {
        this.selectProList = this.selectProList.filter( item => item.id !== data.id)
      }
    },

    // 可选产品列表
    getProList:function(){
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        listType:'page',
        pageNumber:this.pageNumber,
        pageSize: 9999, 
        purchasable: 0,
        useful: '1',
        purchasable: '0'
      }
      this.listLoading = true;
      API_Product.productList(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.total = res.data.data.totalRow;
          for(var i=0;i<res.data.data.list.length;i++){
            if(res.data.data.list[i].purchasable){
              if(res.data.data.list[i].purchasable == 0){
                res.data.data.list[i].purchasabled = "是";
              }else{
                res.data.data.list[i].purchasabled = "否";
              }
            }
            if(res.data.data.list[i].logo){
              // res.data.data.list[i].logo2 = imgURLs + res.data.data.list[i].logo;
              res.data.data.list[i].logo2 = res.data.data.list[i].logo;
            }
            if(res.data.data.list[i].price){
              res.data.data.list[i].price = parseFloat(res.data.data.list[i].price);
            }
          }
          // 初始化产品数量和时长为1
           res.data.data.list.forEach(item => {
            item.purchaseMonth = 1
            item.purchaseNum = 1
          })
          this.proList = res.data.data.list;
          // console.log("this.proList==", this.proList)
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'loginAdmin'});
          }
        }
        this.listLoading = false;
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
        this.listLoading = false;
      });
    },

    changeSouch3:function(val){
      if(val == "ID"){
        this.proName3 = this.souchs3.id;
      }else if(val == "企业名称"){
        this.proName3 = this.souchs3.company;
      }else if(val == "管理员"){
        this.proName3 = this.souchs3.managername;
      }
    },
    changeSouch:function(val){
      this.disSouch=false;
      this.disinvit=false;  
      this.disSofttype=false;
      this.disTime1=false;
      this.disTime2=false;
      if(val == "账号"){
        this.proName = this.souchs2.phone;
        this.disSouch = true;
      }else if(val == "姓名"){
        this.proName = this.souchs2.name;
        this.disSouch = true;
      }else if(val == "企业"){
        this.proName = this.souchs2.company;
        this.disSouch = true;
      }else if(val == "软件类型"){
        this.disSofttype = true;
      }else if(val == "邀请状态"){
        this.disinvit = true;  
      }else if(val == "开始日期"){
        this.disTime1 = true;
      }else if(val == "结束日期"){
        this.disTime2 = true;
      }
    },

    orderSubmit:function(){
      if(this.selectProList.length == 0){
        return;
      }
      this.checkPersonId;
      this.person;
      let userIde = '';
      // 1个人 checkUserId  2企业  checkPersonId
      if(this.person == '1'){
        if(!this.checkUserId){
          this.$message.error('请选择用户！');
          return;
        }else{
          this.checkPersonId = '';
        }
      }else if(this.person == '2'){
        if(!this.checkPersonId){
          this.$message.error('请选择用户！');
          return;
        }else{
          this.checkUserId = '';
        }
      }

      // 试用订单总价为0
      this.totalPrice = this.orderType == '1'? 0:  this.totalPrice
     
      // var sbmitPrice= 0;
      // console.log('totalPrice==', this.totalPrice)
      // 1试用 2正式
      // if(this.orderType != "1"){
      //   if(!this.totalPrice && this.totalPrice != 0){
      //     this.$message.error('请填写总价！');
      //     return;
      //   }else{
      //     if(isNaN(this.totalPrice)){
      //       this.totalPrice = this.totalPrice.replace(/[^\.\d]/g,'');
      //     }
      //     sbmitPrice = this.totalPrice;
      //   }
      // }

      // 正式版校验订单总价： 不能为空
      if(this.orderType == 2 && this.totalPrice === '') { 
          this.$message.error('请填写总价');
          return;
      }

      let pruductJson =[];
      pruductJson = this.selectProList.map(item => ({
          "productId": item.id,
          "productName":item.name,
          "purchaseMonth":item.purchaseMonth,
          "purchaseNum":item.purchaseNum,
          "singlePrice":item.price,
          "logo": item.logo,
      }))
      
      if(!this.effectiveTime){
        this.$message.error('请选择生效时间');
        return;
      }
      var effectiveTime =  Util.formatDateGu(this.effectiveTime) +' '+ (this.effectiveTimeSfm)
      let param = {
        token: this.token,
        checkCode: this.checkCode,
        type: this.orderType,
        adminuserid: this.id,
        price: this.totalPrice,
        userid: this.checkUserId,
        companyid: this.checkPersonId,
        pruductJson:JSON.stringify(pruductJson),
        mode: this.mode,
        effectiveTime: effectiveTime
      }

      if(this.mode == 'update') {
        param.id = this.orderId
      }
      console.log("param==", param)
      this.orderSubLoading = true;
      API_Order.addOrder(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.$message({
            message: '提交成功',
            type: 'success'
          });
          this.$router.push({path: 'orderList'});
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'loginAdmin'});
          }
        }
        this.orderSubLoading = false;
      }).catch(err =>{
        this.orderSubLoading = false;
        this.$message.error('数据丢失，试试重新登陆！');
      })
    },
 
    getPerson:function(val){
      let _this = this;
      if(this.value3 == "ID"){
        this.souchs3.id = this.proName3;
      }
      if(this.value3 == "企业名称"){
        this.souchs3.company = this.proName3;
      }
      if(this.value3 == "管理员"){
        this.souchs3.managername = this.proName3;
      }
      var flags = true;
      if(val == 1){
        if(this.value3){
          if(this.dynamicTags3.length > 0){
            for(var i=0;i<this.dynamicTags3.length;i++){
              if(this.value3 == this.dynamicTags3[i]){
                flags = false;
              }
            }
          }
          if(flags){
            this.dynamicTags3.push(this.value3);
          }
        }
      }

      let param = {
        token:this.token,
        checkCode:this.checkCode,
        pageNumber:this.pageNumber3,
        pageSize:this.pageSize3,
        userType:'',
        listType:'page',
        managename:this.souchs3.managename,
        id:this.souchs3.id,
        company:this.souchs3.company,
        role: this.userInfo.type,
        userId: this.userInfo.id,
        isCompanyUser: this.person ,    //0个人用户 1企业用户
        searchText: this.searchText
        // searchStr:this.souchs2.modelName,
      }
      this.dialogLoading = true;
      API_User.companyList(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          if(res.data.data){
            _this.total3 = res.data.data.totalRow;
            for(var i=0;i<res.data.data.list.length;i++){
              if(res.data.data.list[i] && _this.checkPersonId && _this.checkPersonId == res.data.data.list[i].id){
                res.data.data.list[i].checked = true;
              }else{
                res.data.data.list[i].checked = false;
              }
            }
            _this.personList = res.data.data.list;
          }
        }else{
          _this.$message.error(res.data.message);
          if(res.data.code == 403){
            _this.$router.push({path: 'loginAdmin'});
          }
        }

        this.dialogLoading = false;
      }).catch(err => {
        this.dialogLoading = false;
        _this.$message.error('数据丢失，试试重新登陆！');
      });
    },

    getUser:function(val){
      let _this = this;
      if(this.value == "账号"){
        this.souchs2.phone = this.proName;
      }
      if(this.value == "企业"){
        this.souchs2.company = this.proName;
      }
      if(this.value == "姓名"){
        this.souchs2.name = this.proName;
      }
      var flag = true;
      if(val == 1){
        if(this.value){
          if(this.dynamicTags.length > 0){
            for(var i=0;i<this.dynamicTags.length;i++){
              if(this.value == this.dynamicTags[i]){
                flag = false;
              }
            }
          }
          if(flag){
            this.dynamicTags.push(this.value);
          }
        }
      }
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        pageNumber:this.pageNumber2,
        pageSize:this.pageSize2,
        username:this.souchs2.name,
        phone:this.souchs2.phone,
        company:this.souchs2.company,
        registertimefrom:this.souchs2.fromtime,
        registertimeto:this.souchs2.totime,
        softtype:this.souchs2.softtype,
        invitestatus:this.souchs2.invitValue,
        userType:'',
        listType:'page',
        // searchStr:this.souchs2.modelName,
        role: this.userInfo.type,
        userId: this.userInfo.id,
        isCompanyUser: this.person ,    //0个人用户 1企业用户
        searchText: this.searchText,
      }
      this.dialogLoading = true;
      API_User.userList(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          if(res.data.data){
            
            this.total2 = res.data.data.totalRow;
            for(var i=0;i<res.data.data.list.length;i++){
              if(res.data.data.list[i] && this.checkUserId && res.data.data.list[i].id == this.checkUserId){
                res.data.data.list[i].checked = true;
              }else{
                res.data.data.list[i].checked = false;
              }
            }
            this.users = res.data.data.list;
          }
          // console.log('this.users==', this.users)
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'loginAdmin'});
          }
        }
        this.dialogLoading = false;
      }).catch(err => {
        this.dialogLoading = false;
        this.$message.error('数据丢失，试试重新登陆！');
      });
    },

    changeFun(e,val){
      // console.log("e-----------", e, this.flag)
      // if(!e){
      //   this.checkUser2 = "";
      //   this.checkUserId = "";
      // }
      // if(e && !this.falg){
      //   this.checkUser2 = this.checkUserOld;
      //   this.checkUserId = this.checkUserIdOld;
      // }
      // console.log('false')
      // this.flag = false;
    },
    changeFun3(e,val){
      // if(!e){
      //   this.checkPerson2 = "";
      //   this.checkPersonId = "";
      // }
      // if(e && !this.falg2){
      //   this.checkPerson2 = this.checkPersonOld;
      //   this.checkPersonId = this.checkPersonIdOld;
      // }
      // this.flag2 = false;
    },
    handleSelectionChange (row, column, event) {
      if(event.target.className.indexOf('el-checkbox__inner') > -1) {
        return;
      }
      this.flag = true;
      this.users.forEach(item => {
        if (item.id !== row.id) {
           item.checked = false;
           this.$set(item, 'checked', false)
        }
        if(item.id == row.id){
          item.checked = true;
          this.$set(item, 'checked', true)
        }
      });
      if(row.name  == null){
        row.name = "";
      }
      if(row.phone == null){
        row.phone = "";
      }
      this.checkUser2 = row.name + ' ' + row.phone;
      this.checkUserOld =  row.name + ' ' + row.phone;
      this.checkUserId = row.id;
      this.checkUserIdOld = row.id;
    },
    handleSelectionChange3(row,column, event) {
      if(event.target.className.indexOf('el-checkbox__inner') > -1) {
        return;
      }
      this.flag2 = true;
      this.personList.forEach(item => {
        if (item.id !== row.id) {
           item.checked = false;
        }
        if(item.id == row.id){
          item.checked = true;
        }
      });
      this.checkPerson2 = row.name;
      this.checkPersonOld = row.name;
      this.checkPersonId = row.id;
      this.checkPersonIdOld = row.id;
    },
    handleCurrentChange3(val) {
      this.pageNumber3 = val;
      this.getPerson();
    },
    handleCurrentChange2(val) {
      this.pageNumber2 = val;
      this.getUser();
    },
    handleUser:function(val){
      if(val == 1){
        this.souchs2 = {};
        this.proName = '';
        this.value = '';
        this.dynamicTags = [];
        this.orderVisible = true;
        this.getUser();
      }else{
        this.souchs3 = {},
        this.value3 = '';
        this.proName3 = '';
        this.dynamicTags3 = [];
        this.personVisible = true;
        this.getPerson();
      }
    },
    orderUserSubmit:function(){
      if(!this.checkUser2){
        this.$message.error('请选择用户！');
        return;
      }
      this.checkUser = this.checkUser2;
      this.orderVisible = false;
      this.searchText = ''
    },
    orderPersonSubmit:function(){
      if(!this.checkPerson2){
        this.$message.error('请选择用户！');
        return;
      }
      this.checkPerson = this.checkPerson2;
      this.personVisible = false;
      this.searchText = ''
    },
  
    getRowClass({ row, column, rowIndex, columnIndex }) {
        if (rowIndex == 0) {
            return "background:#F5F7FA";
        } else {
            return "";
        }
    },
    selsChange: function (sels) {
      this.sels = sels;
    },

    //读取cookie
    getCookie: function() {
      if (document.cookie.length > 0) {
          var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
          for (var i = 0; i < arr.length; i++) {
              var arr2 = arr[i].split('='); //再次切割
              //判断查找相对应的值
              if (arr2[0] == 'dnnyptadmin_token') {
                  this.token = arr2[1]; //保存到保存数据的地方
              } else if (arr2[0] == 'dnnyptadmin_checkCode') {
                  this.checkCode = arr2[1];
              } else if (arr2[0] == 'dnnyptadmin_id') {
                  this.id = arr2[1];
              }
          }
      }
    },
    bak:function(){
      this.$router.push({path: 'orderList'});
    },
    getCode1:function(){
      let _this = this;
      let param = {
        token:this.token,
        checkCode:this.checkCode,
      }
      API_Admin.UserList(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
           _this.softtypes = [];
          for(var i=0;i<res.data.data.length;i++){
            var json = {'value': res.data.data[i].code,'label': res.data.data[i].name}
            _this.softtypes.push(json);
          }
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'loginAdmin'});
          }
        }
      });
    },
    getCode:function(){
      let _this = this;
      let param ={
        token:this.token,
        checkCode:this.checkCode,
        type:7,
      }
      API_User.getCode(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          _this.inviValues = [];
          for(var i=0;i<res.data.data.length;i++){
            var jsons = {"value":res.data.data[i].code,"label":res.data.data[i].name}
            _this.inviValues.push(jsons);
          }
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'loginAdmin'});
          }
        }
      });
    },
    delTags:function(){
      this.souchs2 = {};
      this.proName = '';
      this.value = '';
      this.dynamicTags = [];
      this.getUser();
    },
    handleClose(tag) {
      if(tag == "账号"){
        this.souchs2.phone = '';
        if(this.value == "账号"){
          this.proName = '';
        }
      }
      if(tag == "姓名"){
        this.souchs2.name = '';
        if(this.value == "姓名"){
          this.proName = '';
        }
      }
      if(tag == "企业"){
        this.souchs2.company = '';
        if(this.value == "企业"){
          this.proName = '';
        }
      }
      if(tag == "软件类型"){
        this.souchs2.softtype = "";
      }
      if(tag == "邀请状态"){
        this.souchs2.invitValue = "";
      }
      if(tag == "开始日期"){
        this.souchs2.fromtime ="";
      }
      if(tag == "结束日期"){
        this.souchs2.totime ="";
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    delTags3:function(){
      this.souchs3 = {},
      this.value3 = '';
      this.proName3 = '';
      this.dynamicTags3 = [];
      this.getPerson();
    },
    handleClose3(tag) {
      if(tag == "ID"){
        this.souchs3.id = '';
        if(this.value3 == "ID"){
          this.proName3 = '';
        }
      }
      if(tag == "企业名称"){
        this.souchs3.company = '';
        if(this.value3 == "企业名称"){
          this.proName3 = '';
        }
      }
      if(tag == "管理员"){
        this.souchs3.managername = '';
        if(this.value3 == "管理员"){
          this.proName3 = '';
        }
      }
      this.dynamicTags3.splice(this.dynamicTags3.indexOf(tag), 1);
    },
  },


}
</script>
<style lang="scss">
.order-add-box {
  .detailMain {
    padding: 0 !important;
    overflow: hidden !important;
  }
  .wrapper {
    padding: 10px 20px 0 20px;
     height: calc(100% - 140px);
     overflow-y: auto;
     box-sizing: border-box;
  }
  .order-add-hd {
    margin-bottom: 20px;
    overflow: hidden;
     .el-form-item {
       margin-right: 0;
       margin-bottom: 0;
     }
  }
  .model-edit {
    .el-form-item, .el-tag {
      margin-bottom: 10px;
    }
  }
  
  .order-add-bd {
    .title {
        position: relative;
        left: 6px;
        margin: 0;
        width: 70px;
        font-size: 14px;
        color: #666;
        line-height: 40px;
        padding: 0 10px 0 0;
        font-weight: normal;
    }
    .fit-w {
      flex: 1;
      min-width: 1px;
    }
    .product-list {
      display: flex;
      margin-bottom: 10px;
      .list-bd {
        margin: 0;
        padding: 0;
        overflow: hidden;
        margin-right: -12px;
        .list-item {
          position: relative;
          float: left;
          padding: 16px 8px;
          width: 164px;
          height: 104px;
          margin-right: 12px;
          margin-bottom: 12px;
          text-align: center;
          background: #F7F7F8;
          border-radius: 8px;
          box-sizing: border-box;
          transition: all .2s;
          border: 1px solid #F7F7F8;
          user-select: none;
          cursor: pointer;
          &:hover {
            border-color: #F66B3D;
          }
          &.active {
             border-color: #F66B3D;
             .dnnfont {
               display: block;
             }
          }
          .dnnfont {
            display: none;
            position: absolute;
            left: 12px;
            top: 12px;
            color: #F66B3D;
          }
          .proLogo {
            margin-bottom: 6px;
            width: 45px;
            height: 45px;
            border-radius: 8px;
          }
          .proName {
            margin: 0;
            color: #666;
            font-size: 12px;
            font-weight: normal;
          }
        }
      }
    }
    .product-list-selected {
      display: flex;
      .tab-hd {
        height: 40px;
        line-height: 40px;
        color: #666;
      }
    }
  }

  .order-add-ft {
    width: 100%;
    padding: 6px 20px 0 20px;
    margin-top: 10px;
    padding-bottom: 0;
    border-top: 1px solid #F7F7F8;
    overflow: hidden;
    text-align: right;
    box-sizing: border-box;
      .el-form-item {
      margin: 0;
     }

     .el-input-group__append, .el-input-group__prepend {
       color: #666;
     }

     .order-total {
       .price {
         position: relative;
        top: 5px
       }
     }
  }
 
}
</style>
<style lang="scss" scoped>
.aaaaa .el-table__body-wrapper{
  height:450px;
  overflow-y: auto;
}
.price .el-input__inner{
  height:30px;
}
.order-checkbox{
  position: relative;
  right: 30px;
  float: right;
}
.totalPrice{
  // float: right;
  // position: relative;
  // left: 65px; 
  // padding-top: 10px;
}

.order-sub{
  padding-top: 35px;
  float: right;
  position: relative;
  left: 449px;
}
.orderSubmit{
 
}
.input_Border .el-input__inner{
  border:none;
}
.el-select {
    display: inline-block;
    position: relative;
    width: 115px;
}
.el-tag + .el-tag {
    margin-left: 10px;
}

</style>



// WEBPACK FOOTER //
// OrderAdd.vue?b7aefc38